import CoachLoggedInScreen from './CoachLoggedInScreen';

export default CoachLoggedInScreen;
